import { brandCopy } from '@/copy'
import styles from './Wordmark.module.css'

export function Wordmark({ as: Tag = 'p' }: { as?: 'h1' | 'p' }) {
  return <Tag className={styles.wordmark}>{brandCopy.name}</Tag>
}
